var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPng = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.2rem",
    height: "1.2rem",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Png"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "1.2rem",
    height: "1.2rem",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 11.5H12C11.7348 11.5 11.4804 11.3946 11.2929 11.2071C11.1054 11.0196 11 10.7652 11 10.5V5.5C11 5.23478 11.1054 4.98043 11.2929 4.79289C11.4804 4.60536 11.7348 4.5 12 4.5H15V5.5H12V10.5H14V8.5H13V7.5H15V11.5Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5L7.16 4.5H6V11.5H7V6.5L8.84 11.5H10V4.5H9V9.5Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11.5H1V4.5H4C4.26522 4.5 4.51957 4.60536 4.70711 4.79289C4.89464 4.98043 5 5.23478 5 5.5V8C5 8.26522 4.89464 8.51957 4.70711 8.70711C4.51957 8.89464 4.26522 9 4 9H2V11.5ZM2 8H4V5.5H2V8Z",
    fill: "#161616"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPng, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Png.398dbd9a.svg";
export { ForwardRef as ReactComponent };